export function formatPersianNumber(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
  return String(value).replace(/\d/g, (digit) => persianDigits[Number(digit)] ?? digit);
}

export function formatSolarDate(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '—';

  return new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}
